<template>
    <v-main>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-container fluid class="relative ma-2" v-if="!loading">
            <v-row cols="12">
                <v-col cols="12" class="pr-6">
                    <cardVirtualAssistants :assistants="assistants" :models="models" @updateData="updateData"/>
                </v-col>
            </v-row>
            <v-row cols="12">
                <v-col cols="12" class="pr-6" v-for="assistant in assistants" :key="assistant.id">
                    <cardVirtualAssistant :assistant="assistant" :models="models" @updateData="updateData"/>
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';

    import cardWait from '@/components/syst/openai/cardWait.vue';
    import cardVirtualAssistant from '@/components/syst/openai/cardVirtualAssistant.vue';
    import cardVirtualAssistants from '@/components/syst/openai/cardVirtualAssistants.vue';

    export default {        
        components: {
            navbar,
            cardWait,
            cardVirtualAssistant,
            cardVirtualAssistants,
        },
        data() {
            return {
                loading: true,
                assistants: [],
                models: [],
                vectorStoreCodes: [],
            }
        },
        mounted() {
            this.getAssistants(false);
            this.getModels();
        },
        methods: {
            getAssistants(refresh) {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/openai/getAssistants.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAssistants"
                    },
                    getAssistants: {
                        refresh: refresh,
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.assistants = res.data.getAssistants.assistants;
                        // this.vectorStoreCodes = res.data.getAssistants.vectorStoreCodes;
                        this.loading = false;
                    }
                });
            },
            getModels() {
                this.$axios.post("ares/json/ares/syst/openai/getModels.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getModels",
                    },
                    getModels: {
                        refresh: false,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.models = res.data.getModels;
                    }
                });
            },            
            // Dummy callback for navBar
            actionClick() {

            },           
            updateData(data) {
                switch (data) {
                    case "refresh":
                        this.getAssistants(true);
                        break;
                    default:
                }
            },           
        },
    }
</script>

<style scoped>
</style>
